import { render, staticRenderFns } from "./NewAccount.vue?vue&type=template&id=4837ea8a&scoped=true&"
import script from "./NewAccount.vue?vue&type=script&lang=js&"
export * from "./NewAccount.vue?vue&type=script&lang=js&"
import style0 from "./NewAccount.vue?vue&type=style&index=0&id=4837ea8a&prod&lang=css&"
import style1 from "./NewAccount.vue?vue&type=style&index=1&id=4837ea8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4837ea8a",
  null
  
)

export default component.exports